import {
  Component,
  ElementRef, EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges, OnInit, Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  AppointmentExtProp,
  ConstructionTypes,
  ExtendedProperties,
  IUser,
  LeadComposerChangesModel, LeadsDataAction, LeadsHistory
} from '../../../../models/leads/leads.model';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import { ConvertHelper } from '../../../../helper/convert.helper';
import { ComposerOfferOrOrder } from "../../../../models/action.model";
import { OrderOfferTransferService } from "./order-offer-transfer.service";
import { LeadHelper } from '../../../../helper/lead.helper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Employee, UserRightsDisableReasonModel } from '../../../../models/cloud/cloud.model';
import { BaseCustomDialog } from '../../../shared-module/dialogs/base-custom-dialog';
import { RESOURCES_DATA_SERVICE, ResourcesDataService } from '../../../../services/resources/resources-data.service';
import { CurrencyHelper } from '../../../../helper/app-currency';


export interface OrderOfferDialogData {
  extendedProperties: ExtendedProperties;
  loadedLeadComposerOffers: LeadComposerChangesModel[];
  leadId: number;
  isMyLead: boolean;
  constructionTypeId: number;
  mainOffer: LeadComposerChangesModel;
  mainOrder: LeadComposerChangesModel;
  selectedLeadHistory: LeadsHistory[];
  orderAmountCount: number | undefined;
  limitedAccess: boolean;
  isClosed: boolean;
  constructionTypes: ConstructionTypes[];

  updateConstructionTypeId?: ( id: number ) => any;
  loadComposerOffers?: (
    event?: ComposerOfferOrOrder,
    placeOrder?: boolean,
    onLoadComposer?: ( items: LeadComposerChangesModel[], ) => void,
    onLoadHistory?: ( items: LeadsHistory[], ) => void
  ) => any;
  onAction?: ( name: string, label: string, successCallback?: () => void ) => any,
  actions?: LeadsDataAction[];
}

@Component({
  selector: 'fi-order-offer-dialog',
  templateUrl: './order-offer-dialog.component.html',
  styleUrls: ['./order-offer-dialog.component.scss'],
  standalone: false,
})
export class OrderOfferDialogComponent extends BaseCustomDialog implements OnChanges {
  @Input() extendedProperties: ExtendedProperties;
  @Input() loadedLeadComposerOffers: LeadComposerChangesModel[] = [];
  @Input() leadId: number;
  @Input() isMyLead: boolean;
  @Input() constructionTypeId: number;
  @Input() mainOffer: LeadComposerChangesModel;
  @Input() mainOrder: LeadComposerChangesModel;
  @Input() selectedLeadHistory: LeadsHistory[];
  @Input() orderAmountCount: number | undefined;
  @Input() limitedAccess: boolean;
  @Input() isClosed: boolean;
  @Input() constructionTypes: ConstructionTypes[];

  @ViewChild('planerCodeInput') planerCodeInput: ElementRef;
  @ViewChild('offerNumberInput') offerNumberInput: ElementRef;
  @ViewChild('offerAmountInput') offerAmountInput: ElementRef;
  @ViewChild('offerAppointment') offerAppointment: ElementRef;
  @ViewChild('consultationType') consultationType: ElementRef;


  showPlannerComposition = false;
  showOfferAmount = false;
  showOfferNumber = false;
  showConsultationType = false;
  keyEntered = false;
  currencies = CurrencyHelper.FINSTRAL_CURRENCIES;
  putExtendedProperties: AppointmentExtProp;
  currencyId: number;
  currencyOrderId: number;
  offerAmount: string;
  inValidNumber = false;
  consultationTypeName = '';
  composerOffers: LeadComposerChangesModel[] = [];
  composerOrders: LeadComposerChangesModel[] = [];
  inValidOfferAmount: boolean = false;
  openOrdersAndOffersPopup: any;
  isMobile: boolean;
  pageSizeResize;
  actions?: LeadsDataAction[];
  onAction?: ( name: string, label: string, successCallback?: () => void ) => any


  private updateConstructionTypeId?: ( id: number ) => any;
  private loadComposerOffers?: (
    event?: ComposerOfferOrOrder,
    placeOrder?: boolean,
    onLoadComposer?: ( items: LeadComposerChangesModel[], ) => void,
    onLoadHistory?: ( items: LeadsHistory[], ) => void
  ) => any;

  constructor(
    public dialogRef: MatDialogRef<OrderOfferDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OrderOfferDialogData,
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
  ) {
    super(dialogRef);
    this.extendedProperties = data.extendedProperties;
    this.loadedLeadComposerOffers = data.loadedLeadComposerOffers ?? this.loadedLeadComposerOffers;
    this.leadId = data.leadId;
    this.isMyLead = data.isMyLead;
    this.constructionTypeId = data.constructionTypeId;
    this.mainOffer = data.mainOffer;
    this.mainOrder = data.mainOrder;
    this.selectedLeadHistory = data.selectedLeadHistory ?? this.selectedLeadHistory;
    this.orderAmountCount = data.orderAmountCount;
    this.limitedAccess = data.limitedAccess;
    this.isClosed = data.isClosed;
    this.constructionTypes = data.constructionTypes;
    this.onAction = data.onAction;
    this.actions = data.actions;


    this.updateConstructionTypeId = data.updateConstructionTypeId;
    this.loadComposerOffers = data.loadComposerOffers;

    this.getPageSize();
    this.handleChanges();
  }

  @HostListener('window:resize')
  onResize(): void {
    clearTimeout(this.pageSizeResize)
    this.pageSizeResize = setTimeout(() => {
      this.getPageSize();
    }, 300);
  }

  ngOnChanges( changes: SimpleChanges ): void {
    this.handleChanges(changes);
  }

  private handleChanges( changes?: SimpleChanges ): void {
    if ( !!this.extendedProperties ) {
      this.getCurrencyIdByName();
    }
    this.getOrdersAndOffersFromComposer();

    if ( !changes || changes?.constructionTypeId?.currentValue ) {
      this.consultationTypeName = this.constructionTypes.find(el => el.Id === this.constructionTypeId)?.Description;
    }
    OrderOfferTransferService.selectedLeadHistory = this.selectedLeadHistory;
    OrderOfferTransferService.isClosed.emit(this.isClosed);
  }

  getCurrencyIdByName(): void {
    this.currencies.forEach(el => {
      if ( el.Description === this.extendedProperties.OFFER_CURRENCY ) {
        this.currencyId = el.Id;
      }
    })
  }

  setExtendedProperties( currency: string ): void {
    this.currencies.forEach(el => {
      if ( el.Id.toString() === currency ) {
        this.currencyId = el.Id;
        this.extendedProperties.OFFER_CURRENCY = el.Description;
      }
    })
  }

  setConstructionTypeId( typeId: number ) {
    this.constructionTypeId = typeId;
    this.showConsultationType = false;

    this.leadsDataService.putLeadById(this.leadId, this.constructionTypeId).subscribe(( { success } ) => {
      if ( success ) {
        this.updateConstructionTypeId?.(this.constructionTypeId);
        this.consultationTypeName = this.constructionTypes.find(el => el.Id === this.constructionTypeId).Description;
      }
    });
  }

  editConsultationType(): void {
    this.showConsultationType = false;
  }

  editPlanerCode( propertyType: string, invalid = false ): void {
    if ( invalid ) {
      this.keyEntered = true;
      return;
    }

    const extendedProperties = {
      PLANER_CODE: this.extendedProperties.PLANER_CODE
    };

    this.putExtendedProp(propertyType, extendedProperties);
  }

  editAmount( propertyType: string ): void {
    let sumIsValid = this.sumIsValid();
    if ( !sumIsValid ) {
      return
    }

    const extendedProperties = {
      OFFER_AMOUNT: !this.offerAmount ? this.extendedProperties.OFFER_AMOUNT : ConvertHelper.currencyToNumber(this.offerAmount),
      OFFER_CURRENCY: !!this.extendedProperties.OFFER_AMOUNT ? this.extendedProperties.OFFER_CURRENCY : null
    };

    this.putExtendedProp(propertyType, extendedProperties);
  }

  editNumber( propertyType: string ): void {
    if ( this.numberIsValid ) {
      return;
    }

    const extendedProperties = {
      OFFER_NUMBER: this.extendedProperties.OFFER_NUMBER
    };

    this.putExtendedProp(propertyType, extendedProperties);
  }

  get numberIsValid(): boolean {
    this.inValidNumber = !this.extendedProperties.OFFER_NUMBER.match(/^\d{5,10}A$/m);
    return this.inValidNumber;
  }

  sumIsValid(): boolean {
    if ( !this.offerAmount ) {
      return true;
    }
    this.inValidOfferAmount = !(this.offerAmount + '').match(/^\d+(?:[,.]\d+)*$/g);
    return !this.inValidOfferAmount;
  }

  putExtendedProp( propertyType: string, extendedProperties: ExtendedProperties ): void {
    this.leadsDataService.putExtendedPropertiesByLeadId(this.leadId, extendedProperties)
      .subscribe(( { success, data } ) => {
        if ( success ) {
          this.showView(propertyType, extendedProperties);
        }
      });
  }

  resizeInput = function (): void {
    let size = 10;
    if ( this ) {
      if ( this.value && this.value.length > 10 ) {
        size = this.value.length
      }
      this.style.width = (size * 10) + "px";
      this?.focus();
    }
  }

  handleEdits( event ): void {
    if ( !(event.target as HTMLElement)?.parentElement?.classList?.contains('edit-icon') ) {
      return
    }
    let editElem = (event.target as HTMLElement).parentElement.parentElement.parentElement;
    setTimeout(() => {
      editElem = editElem.querySelector('.edit input');
      this.resizeInput.call(editElem); // immediately call the function
    }, 100);
  }


  showView( propertyType: string, extendedProperties: ExtendedProperties ): void {
    switch ( propertyType ) {
      case 'planer-composition':
        this.showPlannerComposition = false;
        break;
      case 'offer-amount':
        this.showOfferAmount = false;
        this.extendedProperties.OFFER_AMOUNT = extendedProperties.OFFER_AMOUNT;
        break;
      case 'offer-number':
        this.showOfferNumber = false;
        break;
    }
  }

  editPlanerCodeInput(): void {
    this.showPlannerComposition = true;
    this.showOfferAmount = this.showOfferNumber = this.showConsultationType = false;

    setTimeout(() => {
      this.planerCodeInput?.nativeElement?.focus();
    }, 0);
  }

  editOfferNumberInput(): void {
    this.showOfferNumber = true;
    this.showPlannerComposition = this.showOfferAmount = this.showConsultationType = false;

    setTimeout(() => {
      this.offerNumberInput?.nativeElement?.focus();
    }, 0);
  }

  editOfferAmountInput(): void {
    this.showOfferAmount = true;
    this.showPlannerComposition = this.showOfferNumber = this.showConsultationType = false;

    setTimeout(() => {
      this.offerAmountInput?.nativeElement?.focus();
    }, 0);
  }

  editConsultationTypeInput(): void {
    this.showConsultationType = true;
    this.showPlannerComposition = this.showOfferAmount = this.showOfferNumber = false;
  }

  @HostListener('document:click', ['$event'])
  outClickOfferAmount( event ): void {

    if ( !!this.consultationType && !this.consultationType?.nativeElement?.contains(event.target) && this.showConsultationType ) {
      this.showConsultationType = false;
    }

    if ( !!this.offerAppointment && !this.offerAppointment?.nativeElement?.contains(event.target) && this.showOfferAmount ) {
      this.editAmount('offer-amount');
      this.offerAmountInput?.nativeElement?.blur();
    }

    this.handleEdits(event);
  }

  getConstructionIconUrl( typeId: number, isUrl: boolean ): string {
    return LeadHelper.getConstructionIconUrl(typeId, isUrl);
  }

  private getOrdersAndOffersFromComposer(): void {
    this.composerOrders = [];
    this.composerOffers = [];
    this.loadedLeadComposerOffers?.forEach(item => {
      if ( item.IsOrder ) {
        this.composerOrders.push(item);
      } else {
        this.composerOffers.push(item);
      }
    })
    OrderOfferTransferService.composerOffers.emit(this.composerOffers);
    OrderOfferTransferService.composerOrders.emit(this.composerOrders);
  }

  openRowPopup( $event: MouseEvent ): void {
    this.openOrdersAndOffersPopup = !this.openOrdersAndOffersPopup;
    OrderOfferTransferService.closePopup.subscribe(data => {
      this.openOrdersAndOffersPopup = data;
    })
    OrderOfferTransferService.openOrdersAndOffersPopup.emit(this.openOrdersAndOffersPopup);
  }

  private getPageSize(): void {
    this.isMobile = window.innerWidth <= 769;
    OrderOfferTransferService.isMobile.emit(this.isMobile)
  }

  overlayClosed( $event: boolean ): void {
    if ( $event ) {
      this.openOrdersAndOffersPopup = false;
      OrderOfferTransferService.openOrdersAndOffersPopup.emit(this.openOrdersAndOffersPopup)
    }
  }

  loadComposerOffersToParent( $event: { data: ComposerOfferOrOrder; placeOrder: boolean } ): void {
    this.loadComposerOffers?.(
      $event.data,
      $event.placeOrder,
      ( items ) => {
        this.loadedLeadComposerOffers = items;
        this.handleChanges();
      },
      ( items ) => {
        this.selectedLeadHistory = items;
        this.handleChanges();
      });
    OrderOfferTransferService.loadComposerOffers.emit($event.data)
  }

  onClosePopup( message?: string ): void {
    this.clearClassAndCloseDialog(this.dialogRef, message);
  }
}

